export const tiposArquivos = Object.freeze({
    PROTOCOLO: 1,
    FLUXOGRAMA: 2,
    DIRETRIZ: 3,
    DOCUMENTO: 4,
    VIDEO_URL: 5,
    OUTROS: 6,
    LINK_URL: 7,
});

export const tiposArquivosLabel = {
    [tiposArquivos.PROTOCOLO]: 'Protocolo',
    [tiposArquivos.FLUXOGRAMA]: 'Fluxograma',
    [tiposArquivos.DIRETRIZ]: 'Diretriz',
    [tiposArquivos.DOCUMENTO]: 'Documento',
    [tiposArquivos.VIDEO_URL]: 'Vídeo URL',
    [tiposArquivos.OUTROS]: 'Outros',
    [tiposArquivos.LINK_URL]: 'Link URL',
};
